var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-columns',{attrs:{"justify":"flex-start","align":"flex-start"}},_vm._l((_vm.text),function(unit,index){return _c('div',{key:index,class:unit.replace(/'/g, '-')},[_vm._v(_vm._s(unit))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }